import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlastingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "color",
		children: /* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M50.13,90l-.1,0-41.57-24a.22.22,0,0,1-.1-.18V61.37l.1-.12,41.3-23.84a.22.22,0,0,1,.1,0,.2.2,0,0,1,.1,0l41.57,24,.09.12V65.9a.22.22,0,0,1-.1.18L50.23,89.92A.19.19,0,0,1,50.13,90Z"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		id: "Layer_1",
		"data-name": "Layer 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M92.63,61.51a.73.73,0,0,0,0-.22l0-.07a1,1,0,0,0-.09-.21l0-.06a1.1,1.1,0,0,0-.14-.18l0-.05a1.13,1.13,0,0,0-.23-.17l-41.57-24a1.17,1.17,0,0,0-1.2,0L8,60.4a1.13,1.13,0,0,0-.23.17l-.05.06a1.09,1.09,0,0,0-.13.17l0,.06a1.89,1.89,0,0,0-.09.21v0a.69.69,0,0,0,0,.25v4.38a1.2,1.2,0,0,0,.6,1l41.57,24a1.21,1.21,0,0,0,1.2,0L92,66.94a1.2,1.2,0,0,0,.6-1V61.51ZM92,61.1Zm-43,25v1.54L9.76,65.06V63.51ZM89,61.58,50.13,84.05,11,61.43,49.87,39Zm1.2,2.08v1.55L51.33,87.67V86.13Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M40.43,35.72a.93.93,0,0,1,.22,1.08L29.87,60.27l.81-.3a1,1,0,0,1,1.29.89,1,1,0,0,1-.09.4,1,1,0,0,1-.54.5l-2.95,1.09a1,1,0,0,1-1.23-.56l-1.1-3A1,1,0,0,1,26,59a.93.93,0,0,1,.09-.4,1,1,0,0,1,1.77.07l.3.81,9.59-20.86-2.82,1.56a.94.94,0,0,1-1.3-1.24L38,30.23c.54.32,1.09.61,1.65.89l-3,5.94,2.66-1.48A.94.94,0,0,1,40.43,35.72Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M40.5,29.46c-.57-.27-1.13-.57-1.66-.88l3.92-7.8a13.74,13.74,0,0,0,1.64.91Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M47.57,15.38,45.23,20a12.53,12.53,0,0,1-1.64-.92L46,14.41A7.11,7.11,0,0,0,47.57,15.38Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M50.34,14.11a5.1,5.1,0,0,1-3.52-1.41l2.44-4.86h0l0,0s0,0,0-.08l0,0h0l0,0,.06-.06,0,0h0l0,0,.07,0,0,0h0l.09,0h.08l.09,0h.42l0,0,.07,0,.05,0h0l0,0,.07,0,0,0h0l0,0,.05.05,0,0h0l0,0,0,.06,0,0h0s0,0,0,0l0,.07a.08.08,0,0,0,0,0h0l1.79,5.52A5.17,5.17,0,0,1,50.34,14.11Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M46.8,33.3,42.85,56.56A.94.94,0,0,1,41,56.7l-1.09-3.26L37.2,66.66l.73-.48a1,1,0,0,1,1.48.79.68.68,0,0,1,0,.2,1,1,0,0,1-.41.61l-2.64,1.73A1,1,0,0,1,35,69.23L33.29,66.6a1,1,0,0,1-.16-.53,1.23,1.23,0,0,1,0-.19,1,1,0,0,1,1.74-.33l.47.72,3.45-16.62a.94.94,0,0,1,1.81-.1l1,3L45,33C45.56,33.1,46.18,33.21,46.8,33.3Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M47.11,31.48c-.63-.09-1.24-.2-1.85-.34l1.46-8.6a14.17,14.17,0,0,0,3.41.47l-.54,8.68c-.64,0-1.26-.06-1.88-.13l.36-5.71Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M53.05,72.29h0a1,1,0,0,1-.29.68l-2.27,2.19a1,1,0,0,1-1.35,0L47,72.88a1,1,0,0,1-.27-.66v0a1,1,0,0,1,1.64-.65l.61.63.4-23.88-1,1.94a.94.94,0,0,1-1.78-.48l1-16.36c.61.07,1.24.12,1.87.14l-.73,11.73.76-1.5a.93.93,0,0,1,1.77.43l-.46,28,.62-.61A1,1,0,0,1,53.05,72.29Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M50.24,21.16A12.2,12.2,0,0,1,47,20.7l.89-5.18a6.89,6.89,0,0,0,5.43-.25l1.61,5a11.7,11.7,0,0,1-1.79.58l-.64-2,.29,2.07a12.77,12.77,0,0,1-1.86.23l-.5-3.53Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M54.29,31.37c-.62.1-1.24.19-1.87.24L51.21,23a14.48,14.48,0,0,0,1.87-.24Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M66.23,66.09l-1.69,2.66a1,1,0,0,1-1.32.29l-2.66-1.69a1,1,0,0,1-.42-.6,1,1,0,0,1,1.45-1l.73.46L58.21,47.81l-1.16,3.93a.94.94,0,0,1-1.83-.14L52.68,33.44c.63,0,1.25-.14,1.86-.24L56.48,47l1-3.23a.93.93,0,0,1,.93-.68,1,1,0,0,1,.89.73l4.9,21.95.47-.74a1,1,0,0,1,1.74.31A1,1,0,0,1,66.23,66.09Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M58.21,30.3c-.58.22-1.18.41-1.79.58l-2.68-8.29A15,15,0,0,0,55.53,22Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M75.28,59.46,74,62.35a1,1,0,0,1-1.26.5l-2.9-1.24a1,1,0,0,1-.51-.52,1,1,0,0,1,1.27-1.24l.79.35L61.77,36,61,39.37a.93.93,0,0,1-.88.72.92.92,0,0,1-.93-.64L57,32.64c.61-.17,1.2-.36,1.79-.58l1.15,3.56.68-3a.94.94,0,0,1,.85-.72.92.92,0,0,1,.94.58l10.78,27,.34-.8a1,1,0,0,1,1.77,0A1,1,0,0,1,75.28,59.46Z"
			})
		]
	})]
});
export default SvgBlastingSm;
